import styles from '../Button/button-styles.module.css';
import React from 'react';
import { Link, Path } from 'react-router-dom';
import { ButtonProps } from './Button';

interface LinkedButtonProps extends ButtonProps {
    to: string | Partial<Path>;
}

const LinkedButton = ({
    to,
    children,
    outlined,
    secondary,
    fullWidth,
    color,
    size,
    after,
    style,
}: LinkedButtonProps) => {
    return (
        <Link
            to={to}
            className={`${styles.btn} ${outlined ? styles.outline : ''} ${secondary ? styles.secondary : ''} ${
                fullWidth ? styles.fullWidth : ''
            } 
            ${color ? `${styles['color-neutral']}` : ''}
            ${size ? styles[`size-${size}`] : ''}
            `}
            style={style}
        >
            <span className={styles.label}>{children}</span>
            {after && after}
        </Link>
    );
};

export default LinkedButton;
